import { useEffect } from "react";
import { useAnimation, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const leftVariant = {
  visible: {transform: 'TranslateX(0px)', opacity: 1, transition: {duration: 1.2}},
  hidden: {transform: 'TranslateX(-64px)', opacity: 0.4}
}

const rightVariant = {
  visible: {transform: 'TranslateX(0px)', opacity: 1, transition: {duration: 1.2}},
  hidden: {transform: 'TranslateX(64px)', opacity: 0.4}
}

export const LeftFrame = ({ children }) => {
    const controls = useAnimation();
    const [ref, inView] = useInView();
    useEffect(() => {
        if (inView) {
            controls.start("visible");
        }
    }, [controls, inView]);
    return (
        <motion.div
            ref={ref}
            animate={controls}
            initial="hidden"
            variants={leftVariant}
            className="descr-child"
        >
            {children}
        </motion.div>
    ); 
}

export const RightFrame = ({ children }) => {
    const controls = useAnimation();
    const [ref, inView] = useInView();
    useEffect(() => {
        if (inView) {
            controls.start("visible");
        }
    }, [controls, inView]);
    return (
        <motion.div
            ref={ref}
            animate={controls}
            initial="hidden"
            variants={rightVariant}
            className="descr-child"
        >
            {children}
        </motion.div>
    ); 
}

export const GenLeft = ({className, children}) => {
    const controls = useAnimation();
    const [ref, inView] = useInView();
    useEffect(() => {
        if (inView) {
            controls.start("visible");
        }
    }, [controls, inView]);
    return (
        <motion.div
            ref={ref}
            animate={controls}
            initial="hidden"
            variants={leftVariant}
            className={className}
        >
            {children}
        </motion.div>
    ); 
}